import React, { useContext, useEffect, useState } from "react";

import { Tabs, Tab, Box } from "@material-ui/core";
import ManageServicePlusAccounts from "views/Dashboard/ManageServicePlusAccounts/ManageServicePlusAccounts";
import ThriveServicePlusRequest from "views/Dashboard/ThriveServicePlusRequest/ThriveServicePlusRequest"

import ServicePlusAudit from 'views/Dashboard/ServicePlusAudit/ServicePlusAudit';




import Context from 'context/context';


 





export default function SignatureTab() {
  const [value, setValue] = useState(0);
  const { state, dispatch } = useContext(Context);
let disable=true
  const handleChange = (event, newValue) => {
    if(state?.userInfo?.loyalty_organization_name === 'Henry Schein Dental'){
    setValue(newValue);
    }else {
      
      newValue=newValue==1?2:newValue
  

    setValue(newValue);

    }
  };

  // Optional: Store components in an array to easily switch
  const components = [
<ManageServicePlusAccounts/>,
<ThriveServicePlusRequest/>,
<ServicePlusAudit/>
];

 


  return (
    <Box>
  
      <Tabs value={value} onChange={handleChange} aria-label="Points Management Tabs"
      TabIndicatorProps={{
    style: { backgroundColor: '#007bff' }, // e.g., '#1976d2' for blue
  }}>
        <Tab label="Manage Service Plus Accounts" />
        <Tab label="Thrive Service plus Request" />
        <Tab label="Audit Service Plus" />


        

      </Tabs>
   

      <Box sx={{ p: 2 }}>
      {components[value]}
    </Box>
    </Box>
  );
}
